/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { contactCustomFieldsCreateCustomFieldByPhonebookGet } from '../fn/contact-custom-fields/contact-custom-fields-create-custom-field-by-phonebook-get';
import { ContactCustomFieldsCreateCustomFieldByPhonebookGet$Params } from '../fn/contact-custom-fields/contact-custom-fields-create-custom-field-by-phonebook-get';
import { contactCustomFieldsCreateCustomFieldByPhonebookPost } from '../fn/contact-custom-fields/contact-custom-fields-create-custom-field-by-phonebook-post';
import { ContactCustomFieldsCreateCustomFieldByPhonebookPost$Params } from '../fn/contact-custom-fields/contact-custom-fields-create-custom-field-by-phonebook-post';
import { contactCustomFieldsUpdateCustomFieldByPhonebookGet } from '../fn/contact-custom-fields/contact-custom-fields-update-custom-field-by-phonebook-get';
import { ContactCustomFieldsUpdateCustomFieldByPhonebookGet$Params } from '../fn/contact-custom-fields/contact-custom-fields-update-custom-field-by-phonebook-get';
import { contactCustomFieldsUpdateCustomFieldByPhonebookPut } from '../fn/contact-custom-fields/contact-custom-fields-update-custom-field-by-phonebook-put';
import { ContactCustomFieldsUpdateCustomFieldByPhonebookPut$Params } from '../fn/contact-custom-fields/contact-custom-fields-update-custom-field-by-phonebook-put';
import { CustomResult } from '../models/custom-result';
import { CustomResultOfListOfCustomField } from '../models/custom-result-of-list-of-custom-field';

@Injectable({ providedIn: 'root' })
export class ContactCustomFieldsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `contactCustomFieldsCreateCustomFieldByPhonebookGet()` */
  static readonly ContactCustomFieldsCreateCustomFieldByPhonebookGetPath = '/ContactCustomFields/CreateCustomFieldByPhonebook';

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contactCustomFieldsCreateCustomFieldByPhonebookGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  contactCustomFieldsCreateCustomFieldByPhonebookGet$Response(params?: ContactCustomFieldsCreateCustomFieldByPhonebookGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return contactCustomFieldsCreateCustomFieldByPhonebookGet(this.http, this.rootUrl, params, context);
  }

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contactCustomFieldsCreateCustomFieldByPhonebookGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contactCustomFieldsCreateCustomFieldByPhonebookGet(params?: ContactCustomFieldsCreateCustomFieldByPhonebookGet$Params, context?: HttpContext): Observable<Blob> {
    return this.contactCustomFieldsCreateCustomFieldByPhonebookGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `contactCustomFieldsCreateCustomFieldByPhonebookPost()` */
  static readonly ContactCustomFieldsCreateCustomFieldByPhonebookPostPath = '/ContactCustomFields/CreateCustomFieldByPhonebook';

  /**
   * Create Custom Field By Phonebook.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contactCustomFieldsCreateCustomFieldByPhonebookPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contactCustomFieldsCreateCustomFieldByPhonebookPost$Response(params: ContactCustomFieldsCreateCustomFieldByPhonebookPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return contactCustomFieldsCreateCustomFieldByPhonebookPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create Custom Field By Phonebook.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contactCustomFieldsCreateCustomFieldByPhonebookPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contactCustomFieldsCreateCustomFieldByPhonebookPost(params: ContactCustomFieldsCreateCustomFieldByPhonebookPost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.contactCustomFieldsCreateCustomFieldByPhonebookPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `contactCustomFieldsUpdateCustomFieldByPhonebookGet()` */
  static readonly ContactCustomFieldsUpdateCustomFieldByPhonebookGetPath = '/ContactCustomFields/UpdateCustomFieldByPhonebook';

  /**
   * Get By Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contactCustomFieldsUpdateCustomFieldByPhonebookGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  contactCustomFieldsUpdateCustomFieldByPhonebookGet$Response(params?: ContactCustomFieldsUpdateCustomFieldByPhonebookGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfCustomField>> {
    return contactCustomFieldsUpdateCustomFieldByPhonebookGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get By Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contactCustomFieldsUpdateCustomFieldByPhonebookGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contactCustomFieldsUpdateCustomFieldByPhonebookGet(params?: ContactCustomFieldsUpdateCustomFieldByPhonebookGet$Params, context?: HttpContext): Observable<CustomResultOfListOfCustomField> {
    return this.contactCustomFieldsUpdateCustomFieldByPhonebookGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfCustomField>): CustomResultOfListOfCustomField => r.body)
    );
  }

  /** Path part for operation `contactCustomFieldsUpdateCustomFieldByPhonebookPut()` */
  static readonly ContactCustomFieldsUpdateCustomFieldByPhonebookPutPath = '/ContactCustomFields/UpdateCustomFieldByPhonebook';

  /**
   * Update.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contactCustomFieldsUpdateCustomFieldByPhonebookPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contactCustomFieldsUpdateCustomFieldByPhonebookPut$Response(params: ContactCustomFieldsUpdateCustomFieldByPhonebookPut$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return contactCustomFieldsUpdateCustomFieldByPhonebookPut(this.http, this.rootUrl, params, context);
  }

  /**
   * Update.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contactCustomFieldsUpdateCustomFieldByPhonebookPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contactCustomFieldsUpdateCustomFieldByPhonebookPut(params: ContactCustomFieldsUpdateCustomFieldByPhonebookPut$Params, context?: HttpContext): Observable<CustomResult> {
    return this.contactCustomFieldsUpdateCustomFieldByPhonebookPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

}
